document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-image-scroll-slider]');

  if (!slider) return;

  const initSwiper = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 100);
      return;
    }

    const scrollbar = slider.querySelector('[data-image-scroll-slider-scrollbar]');

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: window.innerWidth <= 768 ? 24 : 69,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: false
      },
      watchOverflow: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
        dragSize: 'auto'
      },
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        0: {
          spaceBetween: 24
        },
        769: {
          spaceBetween: 69
        }
      }
    });
  };

  initSwiper();
});